module.exports = __webpack_public_path__ + "img/verificationReportBg.576ec3ac.png";